import { InputSwitch } from 'primereact/inputswitch';
import { twJoin, twMerge } from 'tailwind-merge';

export default function Toggle({ checked, onChange, disabled, className }) {
  return (
    <InputSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      pt={{
        root: () => ({
          className: twMerge(
            `w-7 h-4 rounded-2xl ${
              checked
                ? disabled
                  ? `bg-pv-primary-primary-300`
                  : `hover:bg-pv-primary-primary-800 bg-pv-primary-primary-500`
                : disabled
                ? `bg-pv-neutral-grey-200`
                : `bg-pv-neutral-grey-300 hover:bg-pv-neutral-grey-500`
            }`,
            twJoin(className?.toggle?.root && className.toggle.root)
          ),
        }),
        slider: () => ({
          className: `before:w-3 before:h-3 before:left-0.5 before:top-0.5 before:-mt-0 bg-transparent ${
            checked
              ? disabled
                ? `before:bg-pv-neutral-grey-50 before:transform before:translate-x-3`
                : `before:transform before:translate-x-3`
              : disabled
              ? `before:bg-pv-neutral-grey-50`
              : ``
          }`,
        }),
      }}
    />
  );
}
